<div class="card">
    <div class="flex items-center justify-between mb-4">
        <div class="font-semibold text-xl">{{ translateServ.dictionary['PEN_JOB'] }}</div>
        <button pButton type="button"
                class="p-button-text p-button-sm"
                (click)="toggleShowPendingOnly()">
            <i [ngClass]="showPendingOnly ? 'pi pi-eye' : 'pi pi-eye-slash'" class="mr-2"></i>
            {{ showPendingOnly ? translateServ.dictionary['SHOW_ALL'] : translateServ.dictionary['SHOW_PEN_ONLY'] }}
        </button>
    </div>

    <div class="customer-work-summary">
        <div class="summary-chart">
            <p-chart type="bar" [data]="workComparisonChartData" [options]="workComparisonChartOptions" class="w-full h-full block"></p-chart>
        </div>
    </div>

    <div class="customer-activity-panel">
        <p-table
            [value]="customerActivities" [responsiveLayout]="'scroll'" [scrollable]="true" scrollHeight="420px" styleClass="customer-activity-table">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 40px;"></th>
                    <th style="width: 200px;" class="text-left">{{ translateServ.dictionary['CUSTOMER'] }}</th>
                    <th style="width: 150px;" class="text-right">{{ translateServ.dictionary['PEN_FILES'] }}</th>
                    <th style="width: 150px;" class="text-right">{{ translateServ.dictionary['PEN_JORS'] }}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-user>
                <tr [ngClass]="isCurrentCustomer(user) ? 'highlight-current-customer' : ''">
                    <td class="text-center">
                        <ng-container *ngIf="isCurrentCustomer(user)">
                            <i class="pi pi-cog pi-spin" title="{{ translateServ.dictionary['WORKING'] || 'Working' }}"></i>
                        </ng-container>
                    </td>
                    <td>
                        <span [ngClass]="isCurrentCustomer(user) ? 'counter-highlight' : 'text-surface-900 dark:text-surface-0 font-medium'">
                            {{ user.userName }}
                        </span>
                    </td>
                    <td class="text-right">
                        <span *ngIf="isCurrentCustomer(user); else normalFiles" class="counter-highlight">{{ user.pendingFiles }}</span>
                        <ng-template #normalFiles>{{ user.pendingFiles }}</ng-template>
                    </td>
                    <td class="text-right">
                        <span *ngIf="isCurrentCustomer(user); else normalRows" class="counter-highlight">{{ user.pendingRows }}</span>
                        <ng-template #normalRows>{{ user.pendingRows }}</ng-template>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
